import * as React from 'react';

export const useEnhancedEffect: (effect: React.EffectCallback, deps?: React.DependencyList) => void =
  typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
